var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.comps),function(comp){return _c('v-flex',{key:comp.index,attrs:{"xs12":""}},[_c(comp.value,{tag:"component"})],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }